import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { orderBy } from 'lodash';
import { createBemBlockBuilder, ShowMore } from '@ebsco-ui/ebsco-ui';

import {
  MetadataDetailsList,
  SearchInstanceDto,
  ShowMoreButton,
} from '@app/components';

type NoteTypeMessages = Record<string, MessageDescriptor>;

const notesLimit = 1;

const cnBem = createBemBlockBuilder(['instanceDetailsPage']);

export const getNotesData = (
  instance: SearchInstanceDto,
  noteTypeMessages: NoteTypeMessages
) =>
  orderBy(
    instance.notes?.filter(({ labelKey }) =>
      Boolean(noteTypeMessages[labelKey])
    ),
    [note => Object.keys(noteTypeMessages).indexOf(note.labelKey)]
  );

export const formatNotes = (
  noteTypeMessages: NoteTypeMessages,
  data: SearchInstanceDto['notes'] = []
) => (
  <ShowMore limit={notesLimit} className={cnBem('__showMore')}>
    <ul>
      <ShowMore.Items>
        {data.map(({ labelKey, note }) => (
          <li key={labelKey + note.join()} data-auto={labelKey}>
            <FormattedMessage tagName="h3" {...noteTypeMessages[labelKey]} />
            <MetadataDetailsList details={note} />
          </li>
        ))}
      </ShowMore.Items>
    </ul>
    <ShowMoreButton showMoreLimit={notesLimit} dataLength={data.length} />
  </ShowMore>
);
